<script lang="ts">
  import { onMount } from 'svelte';
  import BriefBuilderWizard from './BriefBuilderWizard.svelte';
  import { GUEST_TRIAL_STORAGE_KEY } from '../../js/guestTrialProducts';
  import { GUEST_BUILDER_NAME_KEY } from './questions';

  let name = 'Guest brief';

  onMount(() => {
    localStorage.setItem(GUEST_TRIAL_STORAGE_KEY, 'btob');
    name = localStorage.getItem(GUEST_BUILDER_NAME_KEY) || 'Guest brief';
  });
</script>

<div class="guest-bb">
  <BriefBuilderWizard guest={true} projectName={name} />
</div>

<style>
  .guest-bb {
    min-height: 100vh;
    background: var(--dashbg);
  }
</style>
